import React, { Component }  from 'react';
import axios from "axios";
import Layout from "./Components/Layout";
import 'react-datepicker/dist/react-datepicker.css'
import PaginatedItems from "./Components/Pagination";
import {Button, Modal} from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import {toast} from "react-toastify";
import QuoteHeaders from "./Data/quotes.json";

const badgeStyles = `
.table-container {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
    overflow-x: hidden;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f8f9fa !important;
}
.table-container table {
    table-layout: fixed;
    width: 100%;
}
.table-container td {
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}
`;

export class SuppliersData extends Component{
    state = {
        records: [],
        search: "",
        show: false,
        popupIndex: 0,
        filtered: false,
        pageNumber:1,
        pageSize: 25,
        totalItems: 0,
        showComm: false,
        suppliers:[],
        selectedOption: 0,
        selectedOptionName: "",
        showFiles: false,
        ssData: [],
        newSupplierSetup: false,
        redirectToAddSupplier: false,
        redirectToAddRecord: false,
        redirectToImportSuppliers: false,
        showFile: false,
        file: null,
        files: [],
        fileType: "",
        fileDataId: 0,
        isAdmin:false,
        showPeakItemModal: false,
        selectedPeakItem: "",
        peakItemData: null,
        peakItemLoading: false,
        showPurchaseItemModal: false, 
        selectedPurchaseItem: "",
        purchaseItemLoading: false,
        purchaseItemData: null,
        showMatlsItemModal: false, 
        selectedMatlsItem: "",
        matlsItemLoading: false,
        matlsItemData: null,
        showFileManagement: false,
        fileManagementType: "", // 'specs' or 'sidi'
        fileManagementData: [],
        currentSupplierDataMasterId: null,
        isUploading: false,
        showFileViewer: false,
        viewerFile: null,
        viewerFileUrl: null,
        viewerFileType: null,
        isLoadingFile: false
    }

    async checkRole(){
        const response = await axios.get('/manage/check-role');
        console.log(response);
        if(response.data === "Admin")
        {
            const isAdmin = true
            this.setState({ isAdmin });
        }
    }

    componentDidMount() {
        // Check URL first (existing logic)
        let pageUrlValue = window.location.href.split('/')[4];
        this.checkRole();   
        
        // Load page size from localStorage
        const persistedPageSize = parseInt(localStorage.getItem('suppliersPageSize')) || 25;
        
        if (pageUrlValue !== undefined) {
            // URL has company ID - prioritize URL over localStorage
            const selectedOption = parseInt(pageUrlValue);
            const persistedSearch = localStorage.getItem('suppliersSearch') || '';

            this.setState({
                selectedOption,
                search: persistedSearch,
                pageSize: persistedPageSize
            }, () => {
                this.saveToLocalStorage(); // Save URL-based selection
                this.getSuppliers(1, selectedOption);
            });
        } else {
            // No URL value - use localStorage
            const persistedSearch = localStorage.getItem('suppliersSearch') || '';
            const persistedSelectedOption = parseInt(localStorage.getItem('suppliersSelectedOption')) || 0;

            this.setState({
                search: persistedSearch,
                selectedOption: persistedSelectedOption,
                pageSize: persistedPageSize
            }, () => {
                this.getSuppliers(1, persistedSelectedOption);
            });
        }
    }

    // New method to handle PeakItem click
    handlePeakItemClick = async (e, peakItem) => {
        e.stopPropagation();
        this.setState({ 
            showPeakItemModal: true, 
            selectedPeakItem: peakItem,
            peakItemLoading: true,
            peakItemData: null
        });

		try {
            let dataObj = {
                 peakItem: peakItem
            }
            const response = await axios.put('get-suppliers-compare-apex-number', dataObj);
            this.setState({ 
                peakItemData: response.data,
                peakItemLoading: false 
            });
        } catch (error) {
            console.error('Error fetching Apex# details:', error);
            toast.error('Failed to fetch item details');
            this.setState({ peakItemLoading: false });
        }
    }
    

    handlePurchasesClick = async (e, peakItem) => {
        e.stopPropagation();
        this.setState({ 
            showPurchaseItemModal: true, 
            purchaseItemLoading: false,
            purchaseItemData: null
        });
        if(peakItem !== null) {
            this.setState({ 
                selectedPurchaseItem: peakItem.trim(),
                 purchaseItemLoading: true,
            });

            try {
                let dataObj = {
                    peakItem: peakItem
                    //peakItem: "10142"
                }
                const response = await axios.put('get-purchases-compare-apex-number', dataObj);
                this.setState({ 
                    purchaseItemData: response.data,
                    purchaseItemLoading: false 
                });
            } catch (error) {
                console.error('Error fetching Purchase details:', error);
                toast.error('Failed to fetch item details');
                this.setState({ purchaseItemLoading: false });
            }
        }
    }

    handleMatlsClick = async (e, peakItem) => {
        e.stopPropagation();
        this.setState({ 
            showMatlsItemModal: true, 
            matlsItemLoading: false,
            matlsItemData: null
        });
        if(peakItem !== null) {
            this.setState({ 
                selectedMatlsItem: peakItem.trim(),
                matlsItemLoading: true,
            });

            try {
                let dataObj = {
                    peakItem: peakItem
                    //peakItem: "60001" 
                }
                const response = await axios.put('get-matls-compare-apex-number', dataObj);
                this.setState({ 
                    matlsItemData: response.data,
                    matlsItemLoading: false 
                });
            } catch (error) {
                console.error('Error fetching Matl\'s details:', error);
                toast.error('Failed to fetch item details');
                this.setState({ matlsItemLoading: false });
            }
        }

    }


    handlePeakItemModalClose = () => {
        this.setState({ 
            showPeakItemModal: false,
            selectedPeakItem: "",
            peakItemData: null,
            peakItemLoading: false
        });
    }

    handlePurchaseItemModalClose = () => {
        this.setState({ 
            showPurchaseItemModal: false,
            selectedPurchaseItem: "",
            purchaseItemData: null,
            purchaseItemLoading: false
        });
    }

    handleMatlsItemModalClose = () => {
        this.setState({ 
            showMatlsItemModal: false,
            selectedMatlsItem: "",
            matlsItemData: null,
            matlsItemLoading: false
        });
    }

    clearAllFilters = () => {
        this.setState({ 
            search: "", 
            selectedOption: 0 
        }, () => {
            this.getSuppliers(1, 0);
        });
    }

    saveToLocalStorage() {
        localStorage.setItem('suppliersSearch', this.state.search);
        localStorage.setItem('suppliersSelectedOption', this.state.selectedOption.toString());
        localStorage.setItem('suppliersSelectedOptionName', this.state.selectedOptionName.toString());
        localStorage.setItem('suppliersPageSize', this.state.pageSize.toString());
    }


    formatDateColor(dateString) {
        if(dateString === undefined) {
            return '#000';
        }
        const [year, month, day] = dateString.split('-');
        const inputDate = new Date(year, month - 1, day, 0,0, 0);

        if (!isNaN(inputDate.getTime())) {
            if(new Date() > inputDate)
            {
                return '#f00'
            }
            else
            {
                return '#000';
            }

        }
    }

    formatDate(dateString) {
        if (dateString !== undefined && dateString.trim() !== '') {
            const [year, month, day] = dateString.split('-');
            const inputDate = new Date(year, month - 1, day, 0,0, 0);

            if (!isNaN(inputDate.getTime())) {
                const formattedDate = inputDate.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
                return formattedDate;
            } else {
                return "Invalid Date";
            }
        } else {
            return "Invalid Input";
        }
    }


    handleShow(e, popupIndex) {
        this.setState({ show: true })
        this.setState({ popupIndex: popupIndex })
    };

    handleComm(e, popupIndex) {
        this.setState({ showComm: true })
        this.setState({ popupIndex: popupIndex })
    };

    handleAddSupplier = () => {
        this.setState({ redirectToAddSupplier: true });
    }

    handleAddRecord = () => {
        this.setState({ redirectToAddRecord: true });
    }

    handleImportSuppliers = () => {
        this.setState({ redirectToImportSuppliers: true });
    }

    formatCurrency(value){
        if (!value) return '-';
        const num = parseFloat(value.toString().replace(/,/g, ''));
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(num);
    };

    formatDateTime(dateString){
        if(dateString !== undefined)
        {
            const myDate = new Date(dateString);

            return  myDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });

        }
    };

    getFormattedDate(dateString) {
        if (dateString !== undefined && dateString.trim() !== '') {
            const [year, month, day] = dateString.split('-');
            const inputDate = new Date(year, month - 1, day, 0,0, 0);

            if (!isNaN(inputDate.getTime())) {
                const formattedDate = inputDate.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
                return formattedDate;
            } else {
                return "Invalid Date";
            }
        } else {
            return "Invalid Input";
        }
    };

    getQuoteContent(keyData) {
        let content = [];
        for (let i = 0; i < this.state.peakItemData.length; i++) {
            let item = this.state.peakItemData[i];
            if(keyData === 'GoodThruDate') {
                content.push(<td>{this.getFormattedDate(item[keyData])}</td>);
            } else if(keyData === 'dateTimeCreated') {
                content.push(<td>{this.formatDateTime(item[keyData])}</td>);
            } else {
                content.push(<td>{item[keyData]}</td>);
            }
        }
        return content;
    };

    getSuppliers(pageNumber = 1, selectedOption = 0) {
        let _self = this;

        let dataObj = {
            search: _self.state.search,
            order: 'desc',
            page: pageNumber,
            pageSize: _self.state.pageSize,
            filterByCompany: selectedOption
        }

        if(_self.state.search !== "") {
            const filtered = true;
            _self.setState({ filtered });
        } else {
            const filtered = false;
            _self.setState({ filtered });
        }

        axios.put(`get-suppliers`, dataObj)
            .then(response => {
                const records = response.data.records;
                const suppliers = response.data.suppliers;
                _self.setState({ records });
                _self.setState({ suppliers });

                const totalItems = response.data.total_records
                _self.setState({ totalItems });

                // Save state after successful API call
                _self.saveToLocalStorage();
            }).catch(error => {
            console.error('There was an error!', error);
        });
    }

    onSearchClick(e) {
        this.saveToLocalStorage(); // Save state before search
        this.getSuppliers(1, this.state.selectedOption);
    }

    onCompareClick(e)
    {
        e.preventDefault();
        console.log(this.state);
        const search = this.state.search;
        if(search !== undefined) {
            window.location.href = "/compare-quotes/"+search;
        }

    }

    onNewSupplierSetup(e)
    {
        e.preventDefault();
        console.log(this.state);
        const newSupplierSetup = true;
        this.setState({newSupplierSetup})
    }

    onSearch(e) {
        const search = e.target.value;
        this.setState({ search }, () => {
            this.saveToLocalStorage(); // Save immediately on search change
        });
    }

    onKeyUp(e) {
        if (e.charCode === 13) {
            console.log('13');
            this.saveToLocalStorage(); // Save state before search
            this.onSearchClick(e);
        }
    }

    clearPersistedState() {
        localStorage.removeItem('suppliersSearch');
        localStorage.removeItem('suppliersSelectedOption');
        this.setState({
            search: '',
            selectedOption: 0
        });
    }

    openPage(e, SupplierDataId, SupplierDataMasterId){
        e.preventDefault();
        window.location.href = "/view/"+SupplierDataId+"/"+SupplierDataMasterId;
    }

    openAddRecordPage(e, SupplierId, SupplierDataId) {
        e.preventDefault();
        window.location.href = "/add-supplier-record/"+SupplierId+"/"+SupplierDataId;
    }

    async deleteItem(e, SupplierDataId, SupplierDataMasterId) {
         e.preventDefault();
        try {
            let data = await axios.delete(`/supplier-item/${SupplierDataId}/${SupplierDataMasterId}`); 
            if(data.data.message) {
              toast.success(data.data.message);
              this.getSuppliers(this.state.pageNumber, this.state.selectedOption);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
            toast.error('Failed to delete user');
        }
    }

    paginatePage = (page)=> {
        console.log(`pageNumber ! ${page}`)
        const pageNumber = page
        this.setState({ pageNumber });
        this.getSuppliers(page, this.state.selectedOption);
    }

    handleClose = ()=> {
        const showFiles = false
        this.setState({ showFiles });
    }

    handleNewSupplierClose = ()=> {
        const newSupplierSetup = false
        this.setState({ newSupplierSetup });
    }

    handleFileClose()
    {
        this.setState({ 
            showFile: false,
            file: null,
            files: [],
            isUploading: false
        })
    }

    async handleFileSubmit(e) {
        e.preventDefault();
        
        if (!this.state.fileType) {
            toast.error('Please select a file type');
            return;
        }
        
        if (!this.state.files || this.state.files.length === 0) {
            toast.error('Please select at least one file');
            return;
        }
        
        // Set uploading state
        this.setState({ isUploading: true });
        
        const formData = new FormData();
        
        // Append all selected files
        for (let i = 0; i < this.state.files.length; i++) {
            formData.append('files', this.state.files[i]);
        }
        
        try {
            let endpoint = '';
            if (this.state.fileType === 'SDS') {
                endpoint = `raws/upload-specs-files/${this.state.fileDataId}`;
            } else if (this.state.fileType === 'SIDI') {
                endpoint = `raws/upload-sidi-files/${this.state.fileDataId}`;
            }
            
            const response = await axios.post(endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            console.log('Response:', response.data);
            toast.success(response.data.message || 'Files uploaded Successfully!');
            this.setState({ isUploading: false });
            this.handleFileClose();
            this.getSuppliers(this.state.pageNumber, this.state.selectedOption);
        } catch (error) {
            console.error('Error submitting data:', error);
            const errorMessage = error.response?.data?.detail || 'Error uploading files!';
            toast.error(errorMessage);
            this.setState({ isUploading: false });
            this.handleFileClose();
        }
    }

    openFileUpload(e, SupplierDataMasterId, type){
        e.preventDefault();
        this.setState({ fileType: type }, () => {
            this.setState({ fileDataId: SupplierDataMasterId })
            this.setState({ showFile: true, showSidi: false, showSpecs: false })
        });

    }

    handleFileChange(e) {
        const selectedFiles = Array.from(e.target.files);
        
        if (selectedFiles.length === 0) {
            this.setState({ 
                file: null,
                files: []
            });
        } else {
            this.setState({ 
                file: selectedFiles[0], // Keep for backward compatibility
                files: selectedFiles // Support multiple files
            });
        }
    }

    handleFileTypeChange(e) {
        this.setState({ fileType: e.target.value });
    }

    handleDownload = async (file) => {
        try {
            // Use backend route for S3 files with authentication
            if (file.s3_key || file.s3_url) {
                const response = await axios.get(`raws/download-s3-file/${file.fileId}`, {
                    responseType: 'blob'
                });
                
                // Create blob URL and trigger download
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                
                // Get filename from response headers or use actualname
                const contentDisposition = response.headers['content-disposition'];
                let filename = file.actualname || 'download';
                if (contentDisposition) {
                    const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                    if (matches && matches[1]) {
                        filename = matches[1].replace(/"/g, '');
                    }
                }
                
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
            } else if (file.filename) {
                // Fallback to old download method for legacy files
                var baseUrl = axios.defaults.baseURL;
                baseUrl += `raws/download/${file.filename}`;
                window.open(baseUrl);
            } else {
                toast.error('File not available for download');
            }
        } catch (error) {
            console.error('Download error:', error);
            const errorMessage = error.response?.data?.detail || 'Error downloading file';
            toast.error(errorMessage);
        }
    }

    handleDeleteFile = async (file) => {
        if (!window.confirm('Are you sure you want to delete this file?')) {
            return;
        }
        
        try {
            await axios.delete(`raws/delete-file/${file.fileId}`);
            toast.success('File deleted successfully');
            
            // Refresh the file list
            this.setState({ showFiles: false }, () => {
                this.handleOpenFiles({ preventDefault: () => {} }, this.state.fileDataId);
            });
        } catch (error) {
            console.error('Error deleting file:', error);
            const errorMessage = error.response?.data?.detail || 'Error deleting file';
            toast.error(errorMessage);
        }
    }

    // New methods for file management popup
    handleFileManagementClick = async (e, supplierDataMasterId, fileType) => {
        e.preventDefault();
        this.setState({ 
            showFileManagement: true, 
            fileManagementType: fileType,
            currentSupplierDataMasterId: supplierDataMasterId,
            fileManagementData: []
        });

        try {
            let endpoint = '';
            if (fileType === 'specs') {
                endpoint = `raws/get-specs-files/${supplierDataMasterId}`;
            } else if (fileType === 'sidi') {
                endpoint = `raws/get-sidi-files/${supplierDataMasterId}`;
            }

            const response = await axios.get(endpoint);
            this.setState({ fileManagementData: response.data.data || [] });
        } catch (error) {
            console.error('Error loading files:', error);
            toast.error('Error loading files');
        }
    }

    handleFileManagementClose = () => {
        this.setState({ 
            showFileManagement: false,
            fileManagementType: '',
            fileManagementData: [],
            currentSupplierDataMasterId: null
        });
    }

    handleFileManagementDelete = async (file) => {
        if (!window.confirm('Are you sure you want to delete this file?')) {
            return;
        }
        
        try {
            await axios.delete(`raws/delete-file/${file.fileId}`);
            toast.success('File deleted successfully');
            
            // Refresh the file management data
            const updatedFiles = this.state.fileManagementData.filter(f => f.fileId !== file.fileId);
            this.setState({ fileManagementData: updatedFiles });
            
            // Refresh main table data
            this.getSuppliers(this.state.pageNumber, this.state.selectedOption);
        } catch (error) {
            console.error('Error deleting file:', error);
            const errorMessage = error.response?.data?.detail || 'Error deleting file';
            toast.error(errorMessage);
        }
    }

    handleFileManagementUpload = () => {
        // Close file management modal and open upload modal
        this.setState({ 
            showFileManagement: false,
            fileType: this.state.fileManagementType === 'specs' ? 'SDS' : 'SIDI',
            fileDataId: this.state.currentSupplierDataMasterId,
            showFile: true
        });
    }

    // File Viewer Methods
    handleViewFile = async (file) => {
        this.setState({ 
            isLoadingFile: true,
            showFileViewer: true,
            viewerFile: file
        });

        try {
            // Get file extension to determine type
            const fileExtension = file.actualname.split('.').pop().toLowerCase();
            const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
            const isPdf = fileExtension === 'pdf';

            if (!isImage && !isPdf) {
                toast.error('File preview is only available for images and PDFs');
                this.setState({ showFileViewer: false, isLoadingFile: false });
                return;
            }

            // Check if this is a confirmation email file (has fileId starting with 'confirmation_')
            const isConfirmationFile = file.fileId && file.fileId.toString().startsWith('confirmation_');
            
            let fileUrl;
            
            if (isConfirmationFile && file.supplierDataId) {
                // For confirmation email files, use the backend endpoint
                const response = await axios.get(`raws/download-confirmation-file/${file.supplierDataId}`, {
                    responseType: 'blob'
                });

                // Create blob URL for viewing
                const contentType = response.headers['content-type'] || 'application/octet-stream';
                const blob = new Blob([response.data], { type: contentType });
                fileUrl = window.URL.createObjectURL(blob);

                this.setState({
                    viewerFileUrl: fileUrl,
                    viewerFileType: isImage ? 'image' : 'pdf',
                    isLoadingFile: false
                });
            } else {
                // For regular files, fetch file content from backend
                const response = await axios.get(`raws/download-s3-file/${file.fileId}`, {
                    responseType: 'blob'
                });

                // Create blob URL for viewing
                const contentType = response.headers['content-type'] || 'application/octet-stream';
                const blob = new Blob([response.data], { type: contentType });
                fileUrl = window.URL.createObjectURL(blob);

                this.setState({
                    viewerFileUrl: fileUrl,
                    viewerFileType: isImage ? 'image' : 'pdf',
                    isLoadingFile: false
                });
            }

        } catch (error) {
            console.error('Error loading file:', error);
            toast.error('Error loading file preview');
            this.setState({ 
                showFileViewer: false, 
                isLoadingFile: false 
            });
        }
    }

    handleCloseViewer = () => {
        // Clean up blob URL
        if (this.state.viewerFileUrl) {
            window.URL.revokeObjectURL(this.state.viewerFileUrl);
        }

        this.setState({
            showFileViewer: false,
            viewerFile: null,
            viewerFileUrl: null,
            viewerFileType: null,
            isLoadingFile: false
        });
    }

    handleDownloadFromViewer = () => {
        if (this.state.viewerFile) {
            this.handleDownload(this.state.viewerFile);
        }
    }

    handleViewConfirmationEmail = async (e, supplierData) => {
        e.preventDefault();
        
        // Create a file object structure similar to what handleViewFile expects
        const fileObj = {
            fileId: `confirmation_${supplierData.SupplierDataId}`, // Create a unique ID
            actualname: `Quote_${supplierData.PeakItem}.pdf`, // Create a readable filename
            s3_url: supplierData.ConfirmationEmailUrl,
            s3_key: supplierData.ConfirmationEmailUrl, // Use URL as key for now
            supplierDataId: supplierData.SupplierDataId // Add this for the backend endpoint
        };

        // Check if the URL points to a viewable file (PDF or image)
        const fileExtension = supplierData.ConfirmationEmailUrl.split('.').pop().toLowerCase();
        const isViewableFile = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);

        if (!isViewableFile) {
            // If not a viewable file, try the backend endpoint first for proper authentication
            try {
                const response = await axios.get(`raws/download-confirmation-file/${supplierData.SupplierDataId}`, {
                    responseType: 'blob'
                });
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error downloading file:', error);
                toast.error('Error accessing file');
            }
            return;
        }

        // Use the existing file viewer for viewable files
        this.handleViewFile(fileObj);
    }

    handleDownload = async (file) => {
        try {
            // Check if this is a confirmation email file
            const isConfirmationFile = file.fileId && file.fileId.toString().startsWith('confirmation_');
            
            if (isConfirmationFile && file.supplierDataId) {
                // For confirmation email files, use the backend endpoint
                const response = await axios.get(`raws/download-confirmation-file/${file.supplierDataId}`, {
                    responseType: 'blob'
                });

                // Create download link
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = file.actualname || 'download';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return;
            }

            // For regular files, use the backend download endpoint
            const response = await axios.get(`raws/download-s3-file/${file.fileId}`, {
                responseType: 'blob'
            });

            // Create download link
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.actualname || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download error:', error);
            const errorMessage = error.response?.data?.detail || 'Error downloading file';
            toast.error(errorMessage);
        }
    }

    handleOpenFiles = (e, SupplierDataId) => {
        e.preventDefault();
        let _self = this;



        // Load both Specs and SIDI files
        Promise.all([
            axios.get(`raws/get-specs-files/${SupplierDataId}`),
            axios.get(`raws/get-sidi-files/${SupplierDataId}`)
        ]).then(responses => {
            const specsFiles = responses[0].data.data || [];
            const sidiFiles = responses[1].data.data || [];
            
            // Combine files - they should already have the correct type information
            const combinedFiles = [...specsFiles, ...sidiFiles];

            _self.setState({ ssData: combinedFiles });
            const showFiles = true;
            _self.setState({ showFiles });
            
        }).catch(error => {
            console.error('There was an error!', error);
            // Fallback to old endpoint if new ones don't exist yet
            axios.get(`get-suppliers-files/${SupplierDataId}`)
                .then(response => {
                    const ssData = response.data.results;
                    _self.setState({ ssData });
                    const showFiles = true;
                    _self.setState({ showFiles });
                }).catch(fallbackError => {
                    console.error('Fallback error:', fallbackError);
                });
        });
        
        
        

    }


    onContactsClick(e){
        e.preventDefault();
        window.location.href = "/suppliers-contacts";
    }

    handleSelectChange = (e) => {
        const selectedOption = parseInt(e.target.value);
        let selectedOptionName = "";
        if(selectedOption > 0)
        {
            const selectedOptionData = this.state.suppliers.find(supplier => 
                supplier.id === selectedOption
            );
            if (selectedOptionData && selectedOptionData.company) {
                selectedOptionName = selectedOptionData.company;
            }
        }
        this.setState({
            search: "",
            selectedOption,
            selectedOptionName
        }, () => {
            this.saveToLocalStorage(); // Save state
            // Callback ensures state is updated before API call
            this.getSuppliers(1, selectedOption);
        });
    }

    handlePageSizeChange = (e) => {
        const pageSize = parseInt(e.target.value);
        this.setState({
            pageSize,
            pageNumber: 1 // Reset to first page when changing page size
        }, () => {
            this.saveToLocalStorage();
            this.getSuppliers(1, this.state.selectedOption);
        });
    }

    handleDownload(file){
        var baseUrl = axios.defaults.baseURL;
        baseUrl += `suppliers/download/${file.fileId}`
        window.open(baseUrl);
    }

    handleFileClick = (e, file) => {
        e.stopPropagation();
        var baseUrl = axios.defaults.baseURL;
        baseUrl += `suppliers/download/${file.fileId}`
        window.open(baseUrl, "_blank");
    }

    formatValue(value) {
        if (value === null || value === undefined || value === '') return '-';
        return value;
    };

    handleViewConfirmationEmail(e, p) {
        if (p && (p.ConfirmationEmailS3Key || p.ConfirmationEmailUrl)) {


            axios.get(`serve-file-simple/${p.SupplierDataId}`, {
                responseType: 'blob' // Important for file downloads
            })
                .then(response => {
                    const contentType = response.headers['content-type'] || 'application/pdf';

                    // Create blob with proper content type
                    const blob = new Blob([response.data], { type: contentType });
                    const fileUrl = window.URL.createObjectURL(blob);

                    // Open file in new window/tab
                    window.open(fileUrl, '_blank');
                    

                    // Clean up the blob URL after a short delay
                    setTimeout(() => window.URL.revokeObjectURL(fileUrl), 1000);
                })
                .catch(error => {
                    console.error('Error fetching file:', error);
                    toast.error('Error loading file');
                });
        } else {
            toast.error('No confirmation email file available');
        }
    };

    render() {
        const hasActiveFilters = this.state.search !== "" || this.state.selectedOption > 0;

        if (this.state.redirectToAddSupplier) {
            return <Navigate to="/add-supplier" />;
        }

        if (this.state.redirectToAddRecord) {
            return <Navigate to="/add-supplier-record" />;
        }

        if (this.state.redirectToImportSuppliers) {
            return <Navigate to="/import-suppliers" />;
        }
        return (
            <Layout>
                <style>{badgeStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'hidden', paddingTop: '20px' }}>

                <Modal 
                    show={this.state.showPeakItemModal} 
                    onHide={this.handlePeakItemModalClose}
                    size="xl"
                    fullscreen={true}
                    dialogClassName="modal-fullscreen"
                >
                    <Modal.Header style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                        <Modal.Title>Apex# - {this.state.selectedPeakItem}</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => this.setState({ showPeakItemModal: false })} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#ffffff', padding: '30px' }}>
                        {this.state.peakItemLoading ? (
                            <div className="text-center p-5">
                                <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-3" style={{ fontSize: '18px' }}>Loading item details...</p>
                            </div>
                        ) : this.state.peakItemData ? (
                           <div className="row">
                                <div className="col-lg-12 mb-12" style={{overflowX: "scroll"}}>
                                    <table className="table table-bordered">
                                        <tbody>
                                        {this.state.peakItemData[0] && QuoteHeaders.map((quote, quoteIndex) => (

                                            <tr>
                                                <td className={'headerStringHistory'}>{quote.header}</td>
                                                {this.getQuoteContent(quote.key)}

                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center p-5">
                                <i className="ti-info-alt" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                <p className="mt-3" style={{ fontSize: '18px' }}>No data available</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '2px solid #dee2e6' }}>
                        <Button variant="secondary" size="lg" onClick={this.handlePeakItemModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal 
                    show={this.state.showPurchaseItemModal} 
                    onHide={this.handlePurchaseItemModalClose}
                    size="xl"
                    fullscreen={true}
                    dialogClassName="modal-fullscreen"
                >
                    <Modal.Header style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                        <Modal.Title>Apex# - {this.state.selectedPurchaseItem}</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => this.setState({ showPurchaseItemModal: false })} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#ffffff', padding: '30px' }}>
                        {this.state.peakItemLoading ? (
                            <div className="text-center p-5">
                                <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-3" style={{ fontSize: '18px' }}>Loading item details...</p>
                            </div>
                        ) : this.state.purchaseItemData !== undefined && this.state.purchaseItemData !== null &&  this.state.purchaseItemData.data.length > 0  ? (<div style={{overflowX: "scroll"}}><table className="table table-hover table-bordered mb-0">
                    <thead className="tableHead">
                      <tr>
                        <th scope="col">Type</th>
                        <th scope="col">Date</th>
                        <th scope="col">Bill #</th>
                        <th scope="col">SKU #</th>
                        <th scope="col">Description</th>
                        <th scope="col">Account</th>
                        <th scope="col" className="text-end">Qty</th>
                        <th scope="col" className="text-center">Unit</th>
                        <th scope="col" className="text-end">Cost</th>
                        <th scope="col" className="text-end">Amount</th>
                        <th scope="col" className="text-end">Balance</th>
              
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.purchaseItemData.data.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span className="text-dark">
                              {item.Type}
                            </span>
                          </td>
                          <td>{this.formatDate(item.Date)}</td>
                          <td><code>{item.Num}</code></td>
                          <td><strong>{item.SkuNum}</strong></td>
                          <td 
                            className="text-truncate" 
                            style={{ maxWidth: '250px' }}
                            title={item.SkuDescription}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                          >
                            {item.SkuDescription}
                          </td>
                          <td><small>{item.Account}</small></td>
                          <td className="text-end fw-semibold">{item.Qty}</td>
                          <td className="text-center text-muted">{item.U_M}</td>
                          <td className="text-end fw-semibold">{this.formatCurrency(item.Cost_Price)}</td>
                          <td className="text-end text-success fw-bold">
                            {this.formatCurrency(item.Amount)}
                          </td>
                          <td className="text-end">{this.formatCurrency(item.Balance)}</td>
         
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={6}></td>
                        <td><span style={{fontWeight: 'bold'}}>{this.state.purchaseItemData.total_qty}</span></td>
                        <td colSpan={2}></td>
                        <td><span style={{fontWeight: 'bold'}} className='text-success'>${this.state.purchaseItemData.total_amount}</span></td>
                        <td colSpan={2}></td>
                      </tr>
                    </tbody>
                  </table> </div>) : (
                            <div className="text-center p-5">
                                <i className="ti-info-alt" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                <p className="mt-3" style={{ fontSize: '18px' }}>No data available</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '2px solid #dee2e6' }}>
                        <Button variant="secondary" size="lg" onClick={this.handlePurchaseItemModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal 
                    show={this.state.showMatlsItemModal} 
                    onHide={this.handleMatlsItemModalClose}
                    size="xl"
                    fullscreen={true}
                    dialogClassName="modal-fullscreen"
                >
                    <Modal.Header style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                        <Modal.Title>Apex# - {this.state.selectedMatlsItem}</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => this.setState({ showMatlsItemModal: false })} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#ffffff', padding: '30px' }}>
                        {this.state.matlsItemLoading ? (
                            <div className="text-center p-5">
                                <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-3" style={{ fontSize: '18px' }}>Loading item details...</p>
                            </div>
                        ) : this.state.matlsItemData !== undefined && this.state.matlsItemData !== null && this.state.matlsItemData.length > 0? (<div style={{overflowX: "scroll"}}>
                            <table className="table table-hover table-bordered mb-0">
                            <thead className="tableHead">
                                <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Raw Material Name</th>
                                <th scope="col">Active/Inactive</th>
                                <th scope="col">Identity Testing Cost</th>
                                <th scope="col">Testing Method</th>
                                <th scope="col">Type/Micro Limit</th>
                                <th scope="col">Common Name</th>
                                <th scope="col">Botanical Name</th>
                                <th scope="col">HOC</th>
                                <th scope="col">Part</th>
                                <th scope="col">Form</th>
                                <th scope="col">Ratio</th>
                                <th scope="col">LOD NMT</th>
                                <th scope="col">LOI NMT</th>
                                <th scope="col">Ingredient Declaration on Label</th>
                                <th scope="col">Identity</th>
                                <th scope="col">Limit 0</th>
                                <th scope="col">Limit 0 Method</th>
                                <th scope="col">Limit 0 Reference</th>
                                <th scope="col">Limit 0 Testing Cost</th>
                                <th scope="col">Active 1</th>
                                <th scope="col">Limit 1</th>
                                <th scope="col">Limit 1 Method</th>
                                <th scope="col">Limit 1 Reference</th>
                                <th scope="col">Limit 1 Testing Cost</th>
                                <th scope="col">Active 2</th>
                                <th scope="col">Limit 2</th>
                                <th scope="col">Limit 2 Method</th>
                                <th scope="col">Limit 2 Reference</th>
                                <th scope="col">Limit 2 Testing Cost</th>
                                <th scope="col">Appearance</th>
                                <th scope="col">Color</th>
                                <th scope="col">Odor</th>
                                <th scope="col">Taste</th>
                                <th scope="col">Bulk</th>
                                <th scope="col">Tapped</th>
                                <th scope="col">Mesh Size</th>
                                <th scope="col">Arsenic</th>
                                <th scope="col">Cadmium</th>
                                <th scope="col">Lead</th>
                                <th scope="col">Mercury</th>
                                <th scope="col">TAMC</th>
                                <th scope="col">TYMC</th>
                                <th scope="col">Coliforms</th>
                                <th scope="col">E. coli</th>
                                <th scope="col">Salmonella spp</th>
                                <th scope="col">Staph aureus</th>
                                <th scope="col">Absent</th>
                                <th scope="col">Milk</th>
                                <th scope="col">Egg</th>
                                <th scope="col">Soy</th>
                                <th scope="col">Fish</th>
                                <th scope="col">Shellfish</th>
                                <th scope="col">Tree Nuts</th>
                                <th scope="col">Peanuts</th>
                                <th scope="col">Wheat</th>
                                <th scope="col">Gluten</th>
                                <th scope="col">Overage</th>
                                <th scope="col">Cost</th>
                                <th scope="col">Cost Unit</th>
                                <th scope="col">Cost/g</th>
                                <th scope="col">MOQ (kg)</th>
                                <th scope="col">Amazon Testing</th>
                                <th scope="col">Laboratory</th>
                                <th scope="col">Solubility (g/mL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.matlsItemData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.Id}</td>
                                    <td className="text-truncate" style={{ maxWidth: '250px' }}>
                                    <strong>{item.RawMaterialName}</strong>
                                    </td>
                                    <td>
                                    {item.ActiveInactive ? (
                                        <span>Active</span>
                                    ) : (
                                        <span>-</span>
                                    )}
                                    </td>
                                    <td className="text-end">{this.formatCurrency(item.IdentityTestingCost)}</td>
                                    <td>{this.formatValue(item.TestingMethod)}</td>
                                    <td>{this.formatValue(item.Type_MicroLimit)}</td>
                                    <td>{this.formatValue(item.CommonName)}</td>
                                    <td>{this.formatValue(item.BotanicalName)}</td>
                                    <td>{this.formatValue(item.HOC)}</td>
                                    <td>{this.formatValue(item.Part)}</td>
                                    <td>{this.formatValue(item.Form)}</td>
                                    <td>{this.formatValue(item.Ratio)}</td>
                                    <td>{this.formatValue(item.LOD_NMT)}</td>
                                    <td>{this.formatValue(item.LOI_NMT)}</td>
                                    <td>{this.formatValue(item.IngredientDeclarationonLabel)}</td>
                                    <td>{this.formatValue(item.Identity)}</td>
                                    <td>{this.formatValue(item.Limit0)}</td>
                                    <td>{this.formatValue(item.Limit0Method)}</td>
                                    <td>{this.formatValue(item.Limit0Reference)}</td>
                                    <td className="text-end">{this.formatCurrency(item.Limit0TestingCost)}</td>
                                    <td>{this.formatValue(item.Active1)}</td>
                                    <td>{this.formatValue(item.Limit1)}</td>
                                    <td>{this.formatValue(item.Limit1Method)}</td>
                                    <td>{this.formatValue(item.Limit1Reference)}</td>
                                    <td className="text-end">{this.formatCurrency(item.Limit1TestingCost)}</td>
                                    <td>{this.formatValue(item.Active2)}</td>
                                    <td>{this.formatValue(item.Limit2)}</td>
                                    <td>{this.formatValue(item.Limit2Method)}</td>
                                    <td>{this.formatValue(item.Limit2Reference)}</td>
                                    <td className="text-end">{this.formatCurrency(item.Limit2TestingCost)}</td>
                                    <td>{this.formatValue(item.Appearance)}</td>
                                    <td>{this.formatValue(item.Color)}</td>
                                    <td>{this.formatValue(item.Odor)}</td>
                                    <td>{this.formatValue(item.Taste)}</td>
                                    <td>{this.formatValue(item.Bulk)}</td>
                                    <td>{this.formatValue(item.Tapped)}</td>
                                    <td>{this.formatValue(item.MeshSize)}</td>
                                    <td>{item.Arsenic && <span className="text-dark">{item.Arsenic}</span>}</td>
                                    <td>{item.Cadmium && <span className="text-dark">{item.Cadmium}</span>}</td>
                                    <td>{item.Leadx && <span className="text-dark">{item.Leadx}</span>}</td>
                                    <td>{item.Mercury && <span className="text-dark">{item.Mercury}</span>}</td>
                                    <td>{this.formatValue(item.TAMC)}</td>
                                    <td>{this.formatValue(item.TYMC)}</td>
                                    <td>{this.formatValue(item.Coliforms)}</td>
                                    <td>{this.formatValue(item.E_coli)}</td>
                                    <td>{this.formatValue(item.Salmonellaspp)}</td>
                                    <td>{this.formatValue(item.Staphaureus)}</td>
                                    <td>{this.formatValue(item.Absent)}</td>
                                    <td>{this.formatValue(item.Milk)}</td>
                                    <td>{this.formatValue(item.Egg)}</td>
                                    <td>{this.formatValue(item.Soy)}</td>
                                    <td>{this.formatValue(item.Fish)}</td>
                                    <td>{this.formatValue(item.Shellfish)}</td>
                                    <td>{this.formatValue(item.TreeNuts)}</td>
                                    <td>{this.formatValue(item.Peanuts)}</td>
                                    <td>{this.formatValue(item.Wheat)}</td>
                                    <td>{this.formatValue(item.Gluten)}</td>
                                    <td>{this.formatValue(item.Overage)}</td>
                                    <td className="text-end fw-semibold">{this.formatCurrency(item.Cost)}</td>
                                    <td>{this.formatValue(item.CostUnit)}</td>
                                    <td className="text-end">{this.formatCurrency(item.Cost_g)}</td>
                                    <td>{this.formatValue(item.MOQ_kg)}</td>
                                    <td className="text-end">{this.formatCurrency(item.AmazonTesting)}</td>
                                    <td>{this.formatValue(item.Laboratory)}</td>
                                    <td>{this.formatValue(item.Solubility_g_mL)}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>) : (
                            <div className="text-center p-5">
                                <i className="ti-info-alt" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                <p className="mt-3" style={{ fontSize: '18px' }}>No data available</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: '#f8f9fa', borderTop: '2px solid #dee2e6' }}>
                        <Button variant="secondary" size="lg" onClick={this.handleMatlsItemModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showFile} onHide={(e) => this.handleFileClose(e)}>
                    <Modal.Header>
                        <Modal.Title>File Upload</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={(e) => this.handleFileClose(e)} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <label>Select File Type</label>
                        <select
                            className={'form-control'}
                            style={{display: "block"}}
                            value={this.state.fileType}  // Add this line
                            onChange={(e) => this.handleFileTypeChange(e)}
                            disabled={this.state.isUploading}
                        >
                            <option value="">Select Type</option>
                            <option value="SDS">Specs</option>
                            <option value="SIDI">SIDI</option>
                        </select>
                        <div style={{marginTop: '14px'}}></div>
                        <label>Select Files (Multiple files supported)</label>
                        <input 
                            type="file" 
                            multiple 
                            onChange={(e) => this.handleFileChange(e)}
                            disabled={this.state.isUploading}
                        />


                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="success" 
                            onClick={(e) => this.handleFileSubmit(e)}
                            disabled={this.state.isUploading}
                        >
                            {this.state.isUploading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight: '5px'}}></span>
                                    Uploading...
                                </>
                            ) : (
                                'Upload'
                            )}
                        </Button>

                        <Button 
                            variant="danger" 
                            onClick={(e) => this.handleFileClose(e)}
                            disabled={this.state.isUploading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showFiles} onHide={(e) => this.handleClose()}>
                    <Modal.Header>
                        <Modal.Title>Specs / SIDI Files</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={(e) => this.handleClose()} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <table style={{width: "100%", borderCollapse: "collapse", border: "1px solid #dee2e6"}}>
                            <thead>
                            <tr>
                                <th style={{border: "1px solid #dee2e6", padding: "8px"}}>Filename</th>
                                <th style={{border: "1px solid #dee2e6", padding: "8px"}}>Type</th>
                                <th style={{border: "1px solid #dee2e6", padding: "8px"}}>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.ssData?.length > 0 ? (
                                this.state.ssData.map((file, index) => (
                                    <tr key={index}>
                                        <td style={{border: "1px solid #dee2e6", padding: "8px"}}>
                                            {file.actualname}
                                        </td>
                                        <td style={{border: "1px solid #dee2e6", padding: "8px"}}>
                                            {file.file_type === 'specs' ? 'Specs' : 
                                             file.file_type === 'sidi' ? 'SIDI' : 
                                             file.type === 1 ? 'Specs' : 'SIDI'}
                                        </td>
                                        <td style={{border: "1px solid #dee2e6", padding: "8px"}}>
                                            <i
                                                className="ti-download pointer"
                                                onClick={() => this.handleDownload(file)}
                                                style={{cursor: "pointer", marginRight: "10px"}}
                                                title="Download"
                                            ></i>
                                            {this.state.isAdmin && (
                                                <i
                                                    className="ti-trash pointer"
                                                    onClick={() => this.handleDeleteFile(file)}
                                                    style={{cursor: "pointer", color: "red"}}
                                                    title="Delete"
                                                ></i>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="3"
                                        style={{border: "1px solid #dee2e6", padding: "8px", textAlign: "center"}}
                                    >
                                        No files found
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={(e) => this.handleClose()}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.newSupplierSetup} onHide={(e) => this.handleNewSupplierClose()}>
                    <Modal.Header>
                        <Modal.Title>New</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={(e) => this.handleNewSupplierClose()} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="card-body">
                            <div className="row col-lg-12 mb-12">
                                <div className="col-lg-4 mb-12" >

                                    <button className='btn btn-success' onClick={this.handleAddSupplier}
                                            style={{padding: '10px', borderRadius: 'unset'}}>
                                        <i className={'ti-plus'}></i>  Supplier
                                    </button>
                                </div>
                                <div className="col-lg-4 mb-12 text-center"
                                     style={{borderLeft: '0px'}}>
                                    <button className='btn btn-success' onClick={this.handleAddRecord}
                                            style={{padding: '10px', borderRadius: 'unset'}}>
                                        <i className={'ti-plus'}></i>  Record
                                    </button>
                                </div>
                                <div className="col-lg-4 mb-12 text-center"
                                     style={{borderLeft: '0px'}}>
                                    <button className='btn btn-success' onClick={this.handleImportSuppliers}
                                            style={{padding: '10px', borderRadius: 'unset'}}>
                                        <i className={'ti-import'}></i>  Import
                                    </button>
                                </div>
                            </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={(e) => this.handleNewSupplierClose()}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px' }}>
                    <div className="container-fluid" style={{ paddingLeft: '24px' }}>
                        
                        {/* Header Section */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Manage and track all supplier quotes and inventory</p>
                            <div className="d-flex" style={{ gap: '10px' }}>
                                {hasActiveFilters &&
                                    <button className='btn btn-outline-danger btn-sm d-flex align-items-center' onClick={this.clearAllFilters}
                                            style={{ gap: '8px', padding: '8px 16px' }}>
                                        <i className={'ti-na'}></i>
                                        Clear Filters
                                    </button>
                                }
                                <button className='btn btn-outline-warning btn-sm d-flex align-items-center' onClick={(e) => this.onContactsClick(e)}
                                        style={{ gap: '8px', padding: '8px 16px' }}>
                                    <i className={'ti-id-badge'}></i>
                                    Contacts
                                </button>
                                {this.state.filtered &&
                                    <button className='btn btn-outline-secondary btn-sm d-flex align-items-center' onClick={(e) => this.onCompareClick(e)}
                                            style={{ gap: '8px', padding: '8px 16px' }}>
                                        <i className={'ti-layout-tab-window'}></i>
                                        Compare
                                    </button>
                                }
                                <button className='btn btn-primary btn-sm d-flex align-items-center' onClick={(e) => this.onNewSupplierSetup(e)}
                                        style={{ gap: '8px', padding: '8px 16px' }}>
                                    <i className={'ti-plus'}></i>
                                    New
                                </button>
                            </div>
                        </div>

                        <div className="row" style={{'@media print': {display: 'none'}}}>
                            <div className="col-lg-12 mb-3">

                                <div className="row">
                                    <div className="col-lg-8">
                                        <div className="input-group">
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                onKeyPress={(e) => this.onKeyUp(e)}
                                                onChange={(e) => this.onSearch(e)}
                                                placeholder="Search by ingredient, SKU or material name..."
                                                value={this.state.search}
                                                style={{padding: '20px'}} 
                                                aria-describedby="basic-addon2"
                                            />
                                            <div className="input-group-append">
                                                <span onClick={(e) => this.onSearchClick(e)} className="input-group-text ti-search" id="basic-addon2"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <select className="custom-select" id="inputGroupSelect01"
                                                value={this.state.selectedOption} onChange={this.handleSelectChange}>
                                            <option value={0}>All Suppliers</option>
                                            {this.state.suppliers.map((option, index) => (
                                                <option key={index} value={option.id}>
                                                    {option.company}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Suppliers List Section */}
                        <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                            <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb' }}>
                                <h5 style={{ fontWeight: '600', margin: 0 }}>Suppliers List ({this.state.totalItems} items)</h5>
                            </div>
                            
                            <div className="table-responsive table-container">
                                <table className="table table-hover mb-0">
                                    <thead style={{ background: '#f8f9fa' }}>
                                        <tr>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '140px' }}>Actions</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Apex#</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '120px' }}>Supplier Name</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>Supplier Item #</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '150px' }}>Item Description</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '60px' }}>MOQ</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Pack Size</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '50px' }}>U/M</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Lead Time</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Tier Qty 1</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>$ Cost</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>Good Thru Date</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '80px' }}>Created</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>Last Updated By</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '50px' }}>Specs</th>
                                            <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '50px' }}>SIDI</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.records.filter(p => p.DataType === undefined).map((p, index) => (
                                            <tr key={index} style={{ borderTop: index > 0 ? '1px solid #f3f4f6' : 'none' }}>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                    
                                                    <i
                                                        className={`ti-pencil-alt pointer ${(p.AddedByPurchasing === null || p.AddedByPurchasing === false) ? 'icon-green' : 'icon-red'}`}
                                                        onClick={(e) => this.openPage(e, p.SupplierDataId, p.SupplierDataMasterId)} title={'Edit'}
                                                    ></i>
                                                               
                                                    <i
                                                        className={`ti-write pointer`} style={{'marginLeft': '3px'}} title={'Revise'}
                                                        onClick={(e) => this.openAddRecordPage(e, p.SupplierId, p.SupplierDataId)}
                                                    ></i>
                                                    { this.state.isAdmin && <i
                                                        className={`ti-trash pointer`} style={{'marginLeft': '3px', 'color': '#f00'}} title={'Delete'}
                                                        onClick={(e) => this.deleteItem(e, p.SupplierDataId, p.SupplierDataMasterId)}
                                                    ></i>

                                                    }

                                                    <i
                                                        className={`ti-shopping-cart pointer`} style={{'marginLeft': '3px'}} title={'Purchases'}
                                                        onClick={(e) => this.handlePurchasesClick(e, p.PeakItem)}
                                                    ></i>

                                                    <i
                                                        className={`ti-package pointer`} style={{'marginLeft': '3px'}} title={'MATL\'s'}
                                                        onClick={(e) => this.handleMatlsClick(e, p.PeakItem)}
                                                    ></i>
                                                    { p.ConfirmationEmailUrl &&                                                     <i
                                                        className={`ti-quote-right pointer`} style={{'marginLeft': '3px'}} title={'Quote'}
                                                        onClick={(e) => this.handleViewConfirmationEmail(e, p)}
                                                    ></i> }

                                                    {p.isActive !== 1 && <i
                                                        className={`ti-na pointer`} style={{'marginLeft': '3px', 'color': '#f00'}} title={'Supplier Inactive'}
                                                    ></i>}

                                                </td>
                                                <td 
                                                    style={{ padding: '12px 8px', border: 'none', fontWeight: '600', textAlign: 'center', cursor: 'pointer' }}
                                                    title='Click To Compare'
                                                    onClick={(e) => this.handlePeakItemClick(e, p.PeakItem)}
                                                >
                                                    {p.PeakItem}
                                                </td>
                                                <td 
                                                    style={{ padding: '12px 8px', border: 'none', textAlign: 'center', cursor: 'pointer' }}
                                                    onClick={(e) => this.openPage(e, p.SupplierDataId, p.SupplierDataMasterId)}
                                                >
                                                    {p.SupplierName}
                                                </td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.SupplierItem}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.ItemDescription}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.MOQ}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.PackSize}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.UM}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.LeadTime}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.TierQty1}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.TierQty1Cost}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                        <p
                                                            style={{
                                                                fontWeight: 'bold',
                                                                color: this.formatDateColor(p.GoodThruDate)
                                                            }}
                                                        >
                                                            {this.formatDate(p.GoodThruDate)}
                                                        </p>
                                                </td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{this.formatDateTime(p.dateTimeCreated)}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.name === null ? 'Supplier' : p.name}</td>

                                                {/* Column for Specs file (type === 1) */}
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                        {p.specs ? (
                                                            <span
                                                                onClick={(e) => this.handleFileManagementClick(e, p.SupplierDataMasterId, 'specs')}
                                                                style={{ marginRight: "5px", cursor: 'pointer', color:'green' }}
                                                                title="Manage Specs files"
                                                            >
                                                                <i className="ti-files"></i> 
                                                              </span>
                                                        ) : (<span style={{marginRight: "5px", color: 'red', cursor: 'pointer'}} onClick={(e) => this.openFileUpload(e, p.SupplierDataMasterId, "SDS")}>
                                                                <i className="ti-upload" title={'upload specs'}></i> 
                                                              </span>)}
                                                </td>

                                                {/* Column for SIDI file (type === 2) */}
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                        {p.sidi ? (
                                                            <span
                                                                onClick={(e) => this.handleFileManagementClick(e, p.SupplierDataMasterId, 'sidi')}
                                                                style={{marginRight: "5px", cursor: 'pointer', color:'green' }}
                                                                title="Manage SIDI files"
                                                            >
                                                            <i className="ti-files"></i> 
                                                          </span>
                                                        ) : (<span style={{marginRight: "5px", color: 'red', cursor: 'pointer'}} onClick={(e) => this.openFileUpload(e, p.SupplierDataMasterId, "SIDI")}>
                                                                <i className="ti-upload" title={'upload sidi'}></i> 
                                                              </span>)}
                                                </td>
                                            </tr>
                                        ))}


                                        {this.state.records.filter(p => p.DataType === "PD").map((p, index) => (
                                            <tr key={`pd-${index}`} style={{ borderTop: '1px solid #f3f4f6' }}>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.PeakItem}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.SupplierName}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.SupplierItem}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.ItemDescription}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.MOQ}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.PackSize}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.UM}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.TierQty1}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.TierQty1Cost}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.GoodThruDate}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>{p.dateTimeCreated}</td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                                <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}></td>
                                            </tr>
                                        ))}

                                        {this.state.records.length === 0 && (
                                            <tr>
                                                <td colSpan="16" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>No Records Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="pagination-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderTop: '1px solid #e5e7eb' }}>
                                <div className="pagination-info" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                    <div className="input-group" style={{ width: 'auto' }}>
                                        <select className="custom-select" id="perPageSelect" value={this.state.pageSize}
                                                onChange={this.handlePageSizeChange}>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <span style={{ color: '#6c757d', fontSize: '14px' }}>
                                        Showing {Math.min((this.state.pageNumber - 1) * this.state.pageSize + 1, this.state.totalItems)} to {Math.min(this.state.pageNumber * this.state.pageSize, this.state.totalItems)} of {this.state.totalItems} entries
                                    </span>
                                </div>
                                <PaginatedItems total={this.state.totalItems}
                                                pageSize={this.state.pageSize}
                                                currentPage={this.state.pageNumber}
                                                onPageChange={this.paginatePage}></PaginatedItems>
                            </div>
                        </div>
                    </div>
                </section>
                
                {/* File Management Modal */}
                <Modal show={this.state.showFileManagement} onHide={this.handleFileManagementClose} size="lg">
                    <Modal.Header>
                        <Modal.Title>
                            Manage {this.state.fileManagementType === 'specs' ? 'Specs' : 'SIDI'} Files
                        </Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.handleFileManagementClose} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ marginBottom: '15px' }}>
                            <button 
                                className="btn btn-success btn-sm"
                                onClick={this.handleFileManagementUpload}
                            >
                                <i className="ti-upload"></i> Upload More Files
                            </button>
                        </div>
                        
                        {this.state.fileManagementData.length > 0 ? (
                            <table style={{width: "100%", borderCollapse: "collapse", border: "1px solid #dee2e6"}}>
                                <thead style={{backgroundColor: "#f8f9fa"}}>
                                    <tr>
                                        <th style={{border: "1px solid #dee2e6", padding: "12px", textAlign: "left"}}>
                                            File Name
                                        </th>
                                        <th style={{border: "1px solid #dee2e6", padding: "12px", textAlign: "center", width: "120px"}}>
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.fileManagementData.map((file, index) => (
                                        <tr key={index}>
                                            <td style={{border: "1px solid #dee2e6", padding: "12px"}}>
                                                <div style={{wordBreak: "break-word"}}>
                                                    {file.actualname}
                                                </div>
                                            </td>
                                            <td style={{border: "1px solid #dee2e6", padding: "12px", textAlign: "center"}}>
                                                <i
                                                    className="ti-eye pointer"
                                                    onClick={() => this.handleViewFile(file)}
                                                    style={{cursor: "pointer", marginRight: "10px", color: "#28a745"}}
                                                    title="View file"
                                                ></i>
                                                <i
                                                    className="ti-download pointer"
                                                    onClick={() => this.handleDownload(file)}
                                                    style={{cursor: "pointer", marginRight: "10px", color: "#007bff"}}
                                                    title="Download file"
                                                ></i>
                                                {this.state.isAdmin && (
                                                    <i
                                                        className="ti-trash pointer"
                                                        onClick={() => this.handleFileManagementDelete(file)}
                                                        style={{cursor: "pointer", color: "#dc3545"}}
                                                        title="Delete file"
                                                    ></i>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div style={{textAlign: "center", padding: "40px", color: "#6c757d"}}>
                                <i className="ti-info-alt" style={{fontSize: "48px", marginBottom: "15px"}}></i>
                                <p style={{fontSize: "16px", margin: "0"}}>
                                    No {this.state.fileManagementType === 'specs' ? 'Specs' : 'SIDI'} files found
                                </p>
                                <p style={{fontSize: "14px", margin: "5px 0 0 0"}}>
                                    Click "Upload More Files" to add files
                                </p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleFileManagementClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* File Viewer Modal */}
                <Modal 
                    show={this.state.showFileViewer} 
                    onHide={this.handleCloseViewer} 
                    size="xl"
                    centered
                >
                    <Modal.Header style={{backgroundColor: "#f8f9fa"}}>
                        <Modal.Title>
                            {this.state.viewerFile?.actualname || 'File Viewer'}
                        </Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.handleViewerClose} style={{border: "none", background: "#fff"}}>
                            <i className="ti-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{backgroundColor: "#f8f9fa", padding: "0"}}>
                        {this.state.isLoadingFile ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "500px"
                            }}>
                                <div className="spinner-border text-primary" role="status" style={{width: "3rem", height: "3rem"}}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "500px",
                                maxHeight: "80vh",
                                overflow: "auto",
                                backgroundColor: "#e9ecef"
                            }}>
                                {this.state.viewerFileType === 'image' && this.state.viewerFileUrl && (
                                    <img 
                                        src={this.state.viewerFileUrl} 
                                        alt={this.state.viewerFile?.actualname}
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "80vh",
                                            objectFit: "contain"
                                        }}
                                    />
                                )}
                                {this.state.viewerFileType === 'pdf' && this.state.viewerFileUrl && (
                                    <div style={{ width: "100%", height: "80vh", position: "relative" }}>
                                        <iframe
                                            src={`${this.state.viewerFileUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                                            title={this.state.viewerFile?.actualname}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                border: "none"
                                            }}
                                        />
                                        <div style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            backgroundColor: "rgba(0,0,0,0.7)",
                                            color: "white",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            fontSize: "12px"
                                        }}>
                                            If PDF doesn't display, click Download to view it locally
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{backgroundColor: "#f8f9fa"}}>
                        <Button 
                            variant="success" 
                            onClick={this.handleDownloadFromViewer}
                            disabled={this.state.isLoadingFile}
                        >
                            <i className="ti-download"></i> Download
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={this.handleCloseViewer}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                
                </div>
            </Layout>
        );
    }
}

export default SuppliersData;